import * as React from 'react';
import { Dialog,DialogFooter  } from 'office-ui-fabric-react/lib/Dialog';
import { PrimaryButton, DefaultButton} from 'office-ui-fabric-react/lib/Button';

import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { Label } from 'office-ui-fabric-react/lib/Label';

import { Config } from './Config.js';
import { Utils } from './classi/Utils.js';

import './css/DialogBox.css';
import './css/PrimoAccesso.css';

const config = new Config();
const utils = new Utils();

export class CompletaRegistrazione extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hidden: false,
            version : config.getVersion(),
            classeHeader : 'loginpage',
            
            id_cliente:'',
            
            password1:'',
            password2:'',
            
            passwordError : '...compilare...',
            passwordError2 : '...compilare...',
            
            buttonDisabled : false,

            checkAbilitato : false,
            
            textCOMPLETAREG : "Completa Registrazione",

            classLogo : 'logo',

            classepassword : 'nascosto',
            classemostra : 'nascosto',
            messaggio : '',
            
            codutente : '',
            cfutente : '',
            mostradatiutente : 'nascosto'
        };

        this.execLogin = this.execLogin.bind(this);
        
        this._controllaAbilitazioneBottone = this._controllaAbilitazioneBottone.bind(this);
        this.controllaParametri = utils.controllaParametri.bind(this);
        
        this.centralogo = this.centralogo.bind(this);
        
        this.controllaProvenienza = this.controllaProvenienza.bind(this);
        
        this.recuperaInfoAuth = this.recuperaInfoAuth.bind(this);
    }
    
    componentDidMount() {
        this.centralogo(0);
        this.controllaParametri(0);
        this.recuperaInfoAuth();
        this.controllaProvenienza();
    }
    
    centralogo(conta){
        let posLogo = utils.getObjInfoSocieta( 'POSIZIONELOGOAC2' , false );
        if( posLogo !== false && conta < 50 ) {  
            if(posLogo === 'centro'){ this.setState({classeHeader: 'loginpage pagecentrato'}); } 
            let logolargo = utils.getObjInfoSocieta( 'LOGOLARGO' , false );
            if( logolargo !== false && logolargo==='SI'){ this.setState({classLogo: 'logo logolargo'}); }
        }
        else { setTimeout( function(){  this.centralogo( conta+1 );  }.bind(this) , 50 ); }
    }
    
    controllaProvenienza(){
        if( window.location.search.indexOf("?auth=RP!AG") > -1 ) { this.setState({textCOMPLETAREG: 'Reset Password Aggregato'}); }
        else if( window.location.search.indexOf("?auth=RP!AM") > -1 ) { this.setState({textCOMPLETAREG: 'Reset Password Amministratore'}); }
        else if( window.location.search.indexOf("?auth=RP!UT") > -1 ) { this.setState({textCOMPLETAREG: 'Reset Password Utente'}); }
        
        //56556 - versione XXfunYY
        else if( window.location.search.indexOf("?auth=RPfunAG") > -1 ) { this.setState({textCOMPLETAREG: 'Reset Password Aggregato'}); }
        else if( window.location.search.indexOf("?auth=RPfunAM") > -1 ) { this.setState({textCOMPLETAREG: 'Reset Password Amministratore'}); }
        else if( window.location.search.indexOf("?auth=RPfunUT") > -1 ) { this.setState({textCOMPLETAREG: 'Reset Password Utente'}); }
        
        else if( window.location.search.indexOf("?auth=RP") > -1 ) { this.setState({textCOMPLETAREG: 'Reset Password'}); }
    }
    
    recuperaInfoAuth(){
        let request = new Request( config.get("customers_completaregister") ,{
            method: 'POST',mode: 'cors', credentials: "include",
            body: JSON.stringify({action:'checkauth' , 'authcode' : window.location.search })
        });

        fetch(request)
        .then(function(response){
            return response.json();
        })
        .then(function(result){
            if (result.success){
                if( 'id_cliente' in result.data ){
                    
                    let mostracod = utils.getObjInfoSocieta( 'MOSTRA_CODCLIENTE' , false );
                    let cf = '';
                    let codice = '';
                    let mostracfcod = 'nascosto';
                    
                    if(mostracod==='SI'){
                        cf = result.data.cf;
                        codice = result.data.cod_cliente;
                        mostracfcod = '';
                    }
                    
                    this.setState({ id_cliente: result.data.id_cliente , classepassword:'' , classemostra:'' , codutente:codice, cfutente:cf, mostradatiutente:mostracfcod });
                }
            } else {
                this.setState({ messaggio: 'Codice autorizzazione non più valido. Non è possibile proseguire.' , classepassword:'nascosto' , classemostra:'nascosto' });
            }
        }.bind(this)).catch(function() {
            this.setState({ messaggio: 'Codice Errato' , classepassword:'nascosto' , classemostra:'nascosto' });
        }.bind(this));
    }
  
    _controllaAbilitazioneBottone()
    {
        setTimeout( function(){
            var abilitato = true;

            if( this.state.passwordError !== ''){ abilitato = false }
            if( this.state.passwordError2 !== ''){ abilitato = false }

            this.setState({ buttonDisabled:!abilitato });
            
        }.bind(this) , 100 );
    }

    password1Changed = (newValue) => { 
        if( newValue.length < 8 ){ this.setState({ password1: newValue, passwordError: 'La Lunghezza della password deve essere almeno di 8 caratteri'}); } 
        else {this.setState({ password1: newValue, passwordError: ''});}
        
        if( this.state.password2 !== newValue ){ this.setState({ passwordError2: 'Le Password devono essere uguali'}); } 
        
        this._controllaAbilitazioneBottone();
    }
    
    password2Changed = (newValue) => {
        if( this.state.password1 !== newValue || newValue === '' ){ this.setState({ password2: newValue, passwordError2: 'Le Password devono essere uguali'}); } 
        else {this.setState({ password2: newValue , passwordError2: ''});}
        
        this._controllaAbilitazioneBottone();
    }
  
    execLogin = (event) => {

        this.setState({messaggio: ''});

        let request = new Request( config.get("customers_completaregister") ,{
            method: 'POST',mode: 'cors', credentials: "include",
            body: JSON.stringify({action:'complete' , 'authcode' : window.location.search , id_cliente:this.state.id_cliente, password: this.state.password1 })
        });

        fetch(request)
        .then(function(response){
            return response.json();
        })
        .then(function(result){
            if (result.success){
                if('id_cliente' in result.data){
                    this.tornalogin();
                } else {
                    this.setState({messaggio: 'Errore'});
                }

            } else {
                this.setState({messaggio: result.message});
            }
        }.bind(this)).catch(function() {
            this.setState({messaggio: 'Errore invio dati'});
        }.bind(this));
        
    }

  
    tornalogin = (event) => {
        // ReactDOM.render(<LoginWindow />, document.getElementById('root'));
        /*  window.location ==>
            host: "clientisviluppo.enerp.biz"
            hostname: "clientisviluppo.enerp.biz"
            href: "https://clientisviluppo.enerp.biz/AC2/build/?auth=RP!UTmnbcvbsdjhbsdjkb,bmnbbjhjksdsd"
            origin: "https://clientisviluppo.enerp.biz"
            pathname: "/AC2/build/"
        */
       // window.location.reload();
       window.location = window.location.origin + window.location.pathname;
    }


    render() {

        return (
        <div id="main-container" className="loginpage">
        <header className={this.state.classeHeader}><span className={this.state.classLogo}>&nbsp;</span>&nbsp;</header>
        
        <Dialog dialogContentProps={{ title : this.state.textCOMPLETAREG }} hidden={this.state.hidden}  modalProps={{ isBlocking: true, containerClassName: 'ms-dialogMainOverride primoaccesso' }} >
            <div>{this.state.messaggio}</div>
            
            <div className={this.state.mostradatiutente}>
                <Label htmlFor="labelcodcliente" className='labelforleft'>Codice Cliente : </Label>
                <Label id="labelcodcliente" className='labelforright' >{this.state.codutente}</Label>
                <Label htmlFor="labelcodcf" className='labelforleft'>Codice Fiscale : </Label>
                <Label id="labelcodcf" className='labelforright' >{this.state.cfutente}</Label>
            </div>
            
            <div>                    
                <TextField className={this.state.classepassword} label="Password" errorMessage={this.state.passwordError} required={true} type="password" value={this.state.password1} iconProps={{iconName: 'Lock'}} onChanged={this.password1Changed} />
                <TextField className={this.state.classepassword} label="Ripeti Password" errorMessage={this.state.passwordError2} required={true} type="password" value={this.state.password2} iconProps={{iconName: 'Lock'}} onChanged={this.password2Changed} />
            </div>
            
            <DialogFooter>
                <PrimaryButton className={this.state.classemostra} text="Completa" primary={true} onClick={this.execLogin} disabled={this.state.buttonDisabled}/>
                <DefaultButton text="Indietro" onClick={this.tornalogin} />
            </DialogFooter>
        </Dialog>
        <footer className="loginpage"><i className="ms-Icon ms-Icon--Info" aria-hidden="true"></i> Versione {this.state.version}</footer>
        </div>
        );
    }
}

export default CompletaRegistrazione;


// WEBPACK FOOTER //
// ./src/AcComponents/CompletaRegistrazione.js